/* eslint-disable @typescript-eslint/no-explicit-any */


export const benefits_economizar = [
  {
    title: 'E-commerce',
    image: '/assets/benefits/ecommerce.gif',
    category: 'Economizar',
    url: '/economizar/ecommerce',
  },
  {
    title: 'Lojas Físicas',
    image: '/assets/benefits/lojas.gif',
    category: 'Economizar',
    url: '/economizar/local',
  },
  {
    title: 'Cinema',
    image: '/assets/benefits/cinema.gif',
    category: 'Economizar',
    url: '/economizar/cinema',
  },
];

export const benefits_para_ler = [
  {
    title: 'Revista',
    image: '/assets/benefits/revista.gif',
    category: 'Benefícios Para Ler',
    url: 'https://www.issuu.com',
  },

  {
    title: 'Audio Books',
    image: '/assets/benefits/audiobooks.gif',
    category: 'Benefícios Para Ler',
    disabled: true,
    url: 'https://www.audible.com.br',
  },
  {
    title: 'Livros',
    image: '/assets/benefits/livros.gif',
    category: 'Benefícios Para Ler',
    url: 'https://www.amazon.com.br/livros-digitais-kindle',
  },
];

export const benefits_beneficios = [
  {
    title: 'Telemedicina',
    image: '/assets/benefits/telemedicina.gif',
    category: 'Benefícios',
    url: 'https://www.telemedicina.com.br',
  },
  {
    title: 'Music',
    image: '/assets/benefits/music.png',
    category: 'Benefícios',
    url: 'https://www.youtube.com/musicpremium',
  },
  {
    title: 'Play',
    image: '/assets/benefits/liggaplay.gif',
    category: 'Benefícios',
    url: 'https://www.googleplay.com',
  },
  {
    title: 'Seguros',
    image: '/assets/benefits/seguros.gif',
    category: 'Benefícios',
    url: 'https://www.sulamericaseguros.com.br',
  },
  {
    title: 'Deezer',
    category: 'Streaming',
    image: '/assets/benefits/deezer.png',
    url: 'https://www.deezer.com/br',
  },
];
// const categories = [
//   { title: 'Economizar' },
//   { title: 'Benefícios Para Ler' },
//   { title: 'Benefícios' },
//   { title: 'Streaming' },
// ];


export const groupByCategory = (array: any[], onlyActive?: boolean) => {
  const grouped = array.reduce(
    (acc, benefit) => {
      const category = benefit.category || benefit.sectionTitle;
      if (!acc[category]) {
        acc[category] = [];
      }
      if (onlyActive && !benefit.active) return acc;
      acc[category].push(benefit);
      return acc;
    },
    {} as Record<string, any[]>
  );

  const keys = Object.keys(grouped).map((category) => ({
    category,
    benefits: grouped[category],
  }));


  const sortedCategories = keys.filter((key) => key.benefits.length > 0).sort((a, b) => {
    const order = ['Streaming', 'TVs', 'Telemedicina', '5G', 'Economizar', 'Benefícios Para Ler', 'Benefícios'];
    return order.indexOf(a.category) - order.indexOf(b.category);
  });

  return sortedCategories;
};

export const streaming = [
  {
    title: 'Netflix',
    category: 'Streaming',
    image: '/assets/benefits/netflix.png',
    url: 'https://www.netflix.com',
  },
  {
    title: 'Prime Video',
    category: 'Streaming',
    image: '/assets/benefits/prime.png',
    url: 'https://www.primevideo.com',
  },
  {
    title: 'Disney+',
    category: 'Streaming',
    image: '/assets/benefits/disney.png',
    url: 'https://www.disneyplus.com/pt-br',
  },
  {
    title: 'Globoplay',
    category: 'Streaming',
    image: '/assets/benefits/globoplay.png',
    url: 'https://www.globoplay.com.br',
  },
  {
    title: 'Spotify',
    category: 'Streaming',
    image: '/assets/benefits/spotify.png',
    url: 'https://www.spotify.com/br',
  },
  {
    title: 'HBO Max',
    category: 'Streaming',
    image: '/assets/benefits/hbo-max.png',
    url: 'https://www.max.com/pt-br',
  },
  {
    title: 'Telecine',
    category: 'Streaming',
    image: '/assets/benefits/telecine.png',
    url: 'https://www.telecine.com.br',
  },
  {
    title: 'Deezer',
    category: 'Streaming',
    image: '/assets/benefits/deezer.png',
    url: 'https://www.deezer.com/br',
  },
  {
    title: 'Livros',
    category: 'Streaming',
    image: '/assets/benefits/livros.gif',
    url: 'https://www.skoob.com.br',
  },
 /*  {
    title: 'Fibra TV',
    category: 'Streaming',
    image: '/assets/benefits/fibra-tv.png',
    url: 'https://www.oi.com.br/fibra',
  }, */
  {
    title: 'Exitlag',
    category: 'Streaming',
    image: '/assets/benefits/exitlag.png',
    url: 'https://www.exitlag.com',
  },
/*   {
    title: '5G Fibralink',
    category: 'Streaming',
    image: '/assets/benefits/5g-fibralink.png',
    url: 'https://www.fibralink.com.br',
  }, */
  {
    title: 'YouTube Premium',
    category: 'Streaming',
    image: '/assets/benefits/youtube-premium.png',
    url: 'https://www.youtube.com/premium',
  },
  {
    title: 'Paramount+',
    category: 'Streaming',
    image: '/assets/benefits/paramount.png',
    url: 'https://www.paramountplus.com/br',
  },
  {
    title: 'Apple TV+',
    category: 'Streaming',
    image: '/assets/benefits/apple-tv.png',
    url: 'https://tv.apple.com/br',
  },
  {
    title: 'SBT Play',
    category: 'Streaming',
    image: '/assets/benefits/sbt-play.png',
    url: 'https://www.sbtplay.com.br',
  },
  {
    title: 'Band Play',
    category: 'Streaming',
    image: '/assets/benefits/band-play.png',
    url: 'https://www.bandplay.com.br',
  },
  {
    title: 'Pluto TV',
    category: 'Streaming',
    image: '/assets/benefits/pluto-tv.png',
    url: 'https://www.plutotv.com/pt-br',
  },
];

// Novas categorias solicitadas
export const tvs = [
  {
    title: 'CDN TV',
    category: 'TVs',
    image: '/assets/benefits/cdntv.jpeg',
    url: 'https://www.cdntv.com.br',
  },
  {
    title: 'IT TV',
    category: 'TVs',
    image: '/assets/benefits/ittv.jpeg',
    url: 'https://www.ittv.com.br',
  },
];

export const telemedicinaCategory = [
  {
    title: 'Mediquo',
    category: 'Telemedicina',
    image: '/assets/benefits/mediquo.png',
    url: 'https://www.mediquo.com.br',
  },
  {
    title: 'SulAmerica',
    category: 'Telemedicina',
    image: '/assets/benefits/sulamerica.png',
    url: 'https://www.sulamericaseguros.com.br/telemedicina',
  },
];

export const fiveG = [
  {
    title: 'Ta Telecom',
    category: '5G',
    image: '/assets/benefits/tatelecom.png',
    url: 'https://www.tatelecombrasil.com.br',
  },
  {
    title: 'Surf',
    category: '5G',
    image: '/assets/benefits/surf.png',
    url: 'https://www.surftelecom.com.br',
  },
  {
    title: 'Telecall',
    category: '5G',
    image: '/assets/benefits/telecall.png',
    url: 'https://www.telecall.com.br',
  },
];

export const allBenefits = [
  ...benefits_economizar,
  ...benefits_para_ler,
  ...benefits_beneficios,
  ...streaming,
  ...tvs,
  ...telemedicinaCategory,
  ...fiveG,
];

export const allBenefitsProduct = [
  ...streaming,
  ...tvs,
  ...telemedicinaCategory,
  ...fiveG,
];
